import React, { useEffect, useState, useRef } from 'react';
import Shape from '../Data/Shape';
import Size from '../Data/Size';
import Color from '../Data/Color';
import Clarity from '../Data/Clarity';
import Cut from '../Data/Cut';
import CloseImg from '../assets/download.png'
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Floro from '../Data/Floro';
import { Labdata, Type } from '../Data/Labdata';
import { Modal, Radio, Spin } from 'antd';
import { removeFcmToken } from '../utils/removeFcmToken';
import FancyIntensityData from '../Data/FancyIntensity';
import FancyOvertoneData from '../Data/FancyOvertone';
import FancyColorData from '../Data/FancyColor';
import GIA_LAB_SHAPE_DATA from '../Data/GIALabShapeData';
import IGI_LAB_SHAPE_DATA from '../Data/IGILabShapeData';
import { IoClose } from "react-icons/io5";
import * as XLSX from 'xlsx';
import { Oval, RotatingLines } from 'react-loader-spinner';

// Binary string to ArrayBuffer (same pattern as Inward.js / Stock.js Excel export)
const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }
  return buf;
};

/** Rows: { STOCK_PREFIX, VENDORMESSAGE } from failed inquiry API calls */
const downloadInquiryFailedExcel = (rows) => {
  if (!rows || rows.length === 0) return;
  const excelData = [
    ['STOCK_PREFIX', 'VENDORMESSAGE'],
    ...rows.map((r) => [
      r.STOCK_PREFIX ?? '',
      r.VENDORMESSAGE ?? ''
    ])
  ];
  const ws = XLSX.utils.aoa_to_sheet(excelData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Failed Inquiries');
  const wbBinary = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
  const blob = new Blob([s2ab(wbBinary)], { type: 'application/octet-stream' });
  const ts = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
  const filename = `Inquiry_Failed_${ts}.xlsx`;
  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download = filename;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(downloadLink.href);
};

// Helper function to get fancy data from localStorage or fallback to imported data
const getFancyIntensity = () => {
  const stored = localStorage.getItem('FancyIntensityData');
  return stored ? JSON.parse(stored) : FancyIntensityData;
};

const getFancyOvertone = () => {
  const stored = localStorage.getItem('FancyOvertoneData');
  return stored ? JSON.parse(stored) : FancyOvertoneData;
};

const getFancyColor = () => {
  const stored = localStorage.getItem('FancyColorData');
  return stored ? JSON.parse(stored) : FancyColorData;
};

function Search() {

  const [isVendor] = useState(() => {
    const storedShape = localStorage.getItem("IS_VENDOR");
    return storedShape || '';
  });
  const [ShapeName, setShapeName] = useState(() => { const storedShape = localStorage.getItem("Shape"); return storedShape ? JSON.parse(storedShape) : []; });
  const [sizeCode, setSizecode] = useState(() => { const storedShape = localStorage.getItem("size"); return storedShape ? JSON.parse(storedShape) : []; });
  const [sizeFrom, setSizefrom] = useState(() => { const storedShape = localStorage.getItem("sizeFrom"); return storedShape ? JSON.parse(storedShape) : ''; });
  const [sizeTo, setSizeto] = useState(() => { const storedShape = localStorage.getItem("sizeTo"); return storedShape ? JSON.parse(storedShape) : []; });
  const [ratioFrom, setRatioFrom] = useState(() => { const storedShape = localStorage.getItem("ratioFrom"); return storedShape ? JSON.parse(storedShape) : ''; });
  const [ratioTo, setRatioTo] = useState(() => { const storedShape = localStorage.getItem("ratioTo"); return storedShape ? JSON.parse(storedShape) : []; });
  const [colorCode, setColorcode] = useState(() => { const storedShape = localStorage.getItem("Color"); return storedShape ? JSON.parse(storedShape) : []; });
  const [FancyOvertone, setFancyOvertone] = useState(() => {
    const storedFancyOvertone = localStorage.getItem("FancyOvertone");
    return storedFancyOvertone ? storedFancyOvertone.split('-').filter(v => v.trim() !== '') : [];
  });
  const [FancyIntensity, setFancyIntensity] = useState(() => {
    const storedShape = localStorage.getItem("FancyIntensity");
    return storedShape ? storedShape.split('-').filter(v => v.trim() !== '') : [];
  });

  const [FancyColor, setFancyColor] = useState(() => {
    const storedShape = localStorage.getItem("FancyColor");
    return storedShape ? storedShape.split('-').filter(v => v.trim() !== '') : [];
  });

  const [reportNo, setReport] = useState(() => {
    const storedShape = localStorage.getItem("reportNo");
    return storedShape || 'CERT';
  });

  const [location, setLocation] = useState(() => {
    const storedShape = localStorage.getItem("Location");
    return storedShape || '';
  });
  const [clarityCode, setClaritycode] = useState(() => { const storedShape = localStorage.getItem("clarityCode"); return storedShape ? JSON.parse(storedShape) : []; });
  const [FluoreCode, setFlorocode] = useState(() => { const storedShape = localStorage.getItem("FluoreCode"); return storedShape ? JSON.parse(storedShape) : []; });
  const [labCode, setLabcode] = useState(() => { const storedShape = localStorage.getItem("labCode"); return storedShape ? JSON.parse(storedShape) : []; });
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [stoneIdList, setStoneIdList] = useState(() => { const storedShape = localStorage.getItem("ReportNo:"); return storedShape ? JSON.parse(storedShape) : '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [checked, setChecked] = useState(() => {
    const storedShape = localStorage.getItem("Check");
    return storedShape === "true"; // Convert string to boolean
  });
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isLabGrown, setIsLabGrown] = useState(() => {
    const storedShape = localStorage.getItem("IS_LABGROWN") ? localStorage.getItem("IS_LABGROWN") : "yes";
    return storedShape === "yes"; // Convert string to boolean
  });
  const [typeCode, setTypeCode] = useState(() => {
    const storedType = localStorage.getItem("LAB_TYPE");
    return storedType ? typeof storedType === "string" ? JSON.parse(storedType) : storedType : [];
  });
  const [hiddenInputValue, setHiddenInputValue] = useState('');
  const [showRefButton, setShowRefButton] = useState(false);
  const loginValidated = useRef(false);

  const [isLabPredifinedShapes, setIsLabPredifinedShapes] = useState(false);

  const loginOnReload = async () => {
    const email = localStorage.getItem('USERNAME');
    const password = localStorage.getItem('PASSWORD');
    if (!email || !password) {
      navigate('/');
      return;
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/login`, {
        method: 'POST',
        body: JSON.stringify({
          USERNAME: email,
          PASSWORD: password
        }),
        headers: {
          'Content-type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.success === 'TRUE') {
        localStorage.setItem("USERNAME", email);
        localStorage.setItem("PASSWORD", password);
        localStorage.setItem("IS_CONFIRM", data.message.IS_CONFIRM);
        localStorage.setItem("IS_VENDOR", data.message.IS_VENDOR);
        localStorage.setItem("IS_HOLD", data.message.IS_HOLD);
        localStorage.setItem("IS_CLIENT_PRICE", data.message.IS_CLIENT_PRICE);
        localStorage.setItem("IS_CLIENT_WEB", data.message.IS_CLIENT_WEB);
        localStorage.setItem("IS_VENDOR_NAME", data.message.IS_VENDOR_NAME);
        localStorage.setItem("IS_STAFF", data.message.IS_STAFF);
        localStorage.setItem("IS_RECEIVE", data.message.IS_RECEIVE);
        localStorage.setItem("IS_EXCEL_INWARD", data.message.IS_EXCEL_INWARD);
        localStorage.setItem("IS_SHOW_HOLD_BUTTON", data.message.IS_SHOW_HOLD_BUTTON);
        localStorage.setItem("IS_PRICE_EXCEL", data.message.IS_PRICE_EXCEL);
        localStorage.setItem("IS_HOLD_INQURY", data.message.IS_HOLD_INQURY);
        return true;
      } else {
        toast.error(data.message?.MSG || 'Session expired. Please login again.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        });
        navigate('/');
      }
    } catch (error) {
      toast.error('Unable to validate session. Please login again.', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });
      navigate('/');
    }
  };

  const handleRadioButtonChange = (event) => {
    setIsLabGrown(event.target.value === 'LabGrown');
    setTypeCode([]);
  };

  const handleHiddenInputChange = (e) => {
    const value = e.target.value;
    setHiddenInputValue(value);
    setShowRefButton(value === '1234');
  };

  const [fancyIntensityList, setFancyIntensityList] = useState(getFancyIntensity);
  const [fancyOvertoneList, setFancyOvertoneList] = useState(getFancyOvertone);
  const [fancyColorList, setFancyColorList] = useState(getFancyColor);

  const handleRefreshFancyData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/refreshFancyData`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      await handleFetchGiaLabShapeDropdown();
      await handleFetchIgiLabShapeDropdown();

      if (result.success && result.data) {
        // Extract values from database result format
        const intensityValues = result.data.FancyIntensity.map(item => item.FancyIntensity || item);
        const overtoneValues = result.data.FancyOvertone.map(item => item.FancyOvertone || item);
        const colorValues = result.data.FancyColor.map(item => item.FancyColor || item);

        // Store in localStorage
        localStorage.setItem('FancyIntensityData', JSON.stringify(intensityValues));
        localStorage.setItem('FancyOvertoneData', JSON.stringify(overtoneValues));
        localStorage.setItem('FancyColorData', JSON.stringify(colorValues));

        // Update state
        setFancyIntensityList(intensityValues);
        setFancyOvertoneList(overtoneValues);
        setFancyColorList(colorValues);
        setHiddenInputValue('');
        setShowRefButton(false);

        toast.success('Fancy data and Lab Shape data refreshed successfully!', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        });
      } else {
        toast.error(result.message || 'Failed to refresh fancy data', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        });
      }
    } catch (error) {
      console.error('Error refreshing fancy data:', error);
      toast.error('Error refreshing fancy data: ' + error.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });
    } finally {
      setLoading(false);
    }
  };

  // WIthout Login function

  // useEffect(() => {
  //   const email = localStorage.getItem('USERNAME')
  //   const password = localStorage.getItem('PASSWORD')

  //   if (!email || !password) {
  //     navigate('/')
  //   }
  // }, [])

  //////////////////////////////////////////////////////////// Shape ///////////////////////////////////////////////////////////////////
  const handleBoxClick = (name) => {
    const isSelected = ShapeName.includes(name);
    if (isSelected) {
      setShapeName(ShapeName?.filter((code) => code !== name));
    } else {
      setShapeName([...ShapeName, name]);
    }
  };

  const handleClearSelection = () => {
    setShapeName([])
  };

  const handleSelectAllClick = () => {
    if (!selectAllChecked) {
      const shapeCodes = Shape.map(shape => shape.code);
      setShapeName(shapeCodes);
    } else {
      setShapeName([])
    }
    setSelectAllChecked(!selectAllChecked);
  };


  //////////////////////////////////////////////////////////// Size ///////////////////////////////////////////////////////////////////
  const handleBoxClick2 = (code) => {
    const isSelected = sizeCode.includes(code);
    if (isSelected) {
      setSizecode(sizeCode?.filter((size) => size !== code))
    } else {
      setSizecode([...sizeCode, code])
    }
  };
  const handleClearSelection2 = () => {
    setSizecode([])
    setSizefrom('')
    setSizeto('')
  };

  const Fromdata = (e) => {
    const value = e.target.value;

    // Regex to allow only digits and up to two decimal places
    const regex = /^\d{0,3}(?:\.\d{0,2})?$/;

    // Check if the input matches the regex pattern
    if (regex.test(value)) {
      setSizefrom(value);
    }
    // setSizefrom(sanitizedValue);
  };
  const Todata = (e) => {
    const value = e.target.value;

    // Regex to allow only digits and up to two decimal places
    const regex = /^\d{0,3}(?:\.\d{0,2})?$/;

    // Check if the input matches the regex pattern
    if (regex.test(value)) {
      setSizeto(value);
    }
  };
  const ratioFromdata = (e) => {
    const value = e.target.value;

    // Regex to allow only digits and up to two decimal places
    const regex = /^\d{0,3}(?:\.\d{0,2})?$/;

    // Check if the input matches the regex pattern
    if (regex.test(value)) {
      setRatioFrom(value);
    }
    // setSizefrom(sanitizedValue);
  };
  const ratioTodata = (e) => {
    const value = e.target.value;

    // Regex to allow only digits and up to two decimal places
    const regex = /^\d{0,3}(?:\.\d{0,2})?$/;

    // Check if the input matches the regex pattern
    if (regex.test(value)) {
      setRatioTo(value);
    }
  };

  //////////////////////////////////////////////////////////// Color ///////////////////////////////////////////////////////////////////
  const handleBoxClick3 = (code) => {
    const isSelected = colorCode.includes(code);
    if (isSelected) {
      setColorcode(colorCode?.filter((size) => size !== code))
    } else {
      setColorcode([...colorCode, code])
    }
  };
  const handleClearSelection3 = () => {
    setColorcode([])
  };

  const handelCheck = () => {
    setChecked(!checked)
    if (checked === false) {
      setColorcode([])
    }
    setFancyOvertone([])
    setFancyIntensity([])
    setFancyColor([])
  }

  const handleTypeSelection = (code) => {
    if (typeCode.includes(code)) {
      setTypeCode(typeCode.filter((type) => type !== code));
    } else {
      setTypeCode(prev => prev.length == 0 ? [code] : [...prev, code]);
    }
  }
  //////////////////////////////////////////////////////////// Clarity ///////////////////////////////////////////////////////////////////
  const handleBoxClick4 = (code) => {
    const isSelected = clarityCode.includes(code);
    if (isSelected) {
      setClaritycode(clarityCode?.filter((size) => size !== code))
    } else {
      setClaritycode([...clarityCode, code])
    }
  };
  const handleClearSelection4 = () => {
    setClaritycode([])
  };

  //////////////////////////////////////////////////////////// Fluore ///////////////////////////////////////////////////////////////////
  const handleBoxClick6 = (code) => {
    const isSelected = FluoreCode.includes(code);
    if (isSelected) {
      setFlorocode(FluoreCode.filter((size) => size !== code));
    } else {
      setFlorocode([...FluoreCode, code])
    }
  };
  const handleClearSelection6 = () => {
    setFlorocode([])
  };

  //////////////////////////////////////////////////////////// Lab ///////////////////////////////////////////////////////////////////
  const handleBoxClick7 = (code) => {
    const isSelected = labCode.includes(code);
    if (isSelected) {
      setLabcode(labCode?.filter((size) => size !== code))
    } else {
      setLabcode([...labCode, code])
    }
  };
  const handleClearSelection7 = () => {
    setLabcode([])
  };



  //////////////////////// Cut ///////////////////////////
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedOptions, setSelectedOptions] = useState(() => { const storedShape = localStorage.getItem("CutArray"); return storedShape ? JSON.parse(storedShape) : []; });
  const [options, setOptions] = useState(() => {
    const storedShape = localStorage.getItem("CutArray");
    const selectedOptions = storedShape ? JSON.parse(storedShape) : [];
    const unselectedOptions = Cut.filter(option => !selectedOptions.some(selectedOption => selectedOption.value === option.value))
    return unselectedOptions;
  });
  const cut = selectedOptions.map((option) => option.code)


  const handleIntensityChange2 = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue !== '') {
      const selectedOption = options.find(option => option.value === selectedValue);
      setSelectedOptions([...selectedOptions, selectedOption]);
      setOptions(options.filter(option => option.value !== selectedValue));
      setSelectedOption('');
    }
  };

  const handleRemoveOption = (option) => {
    // Remove the selected option from selectedOptions
    setSelectedOptions(prevSelectedOptions => prevSelectedOptions.filter(item => item.value !== option.value));
    setOptions([...options, option]);
  };


  const handleClearSelectioncut = () => {
    setSelectedOptions([]);
    setOptions(Cut);
  };

  //////////////////////// Polish ///////////////////////////
  const [selectedOption2, setSelectedOption2] = useState('');
  const [selectedOptions2, setSelectedOptions2] = useState(() => { const storedShape = localStorage.getItem("PolishArray"); return storedShape ? JSON.parse(storedShape) : []; });
  const [options2, setOptions2] = useState(() => {
    const storedShape = localStorage.getItem("PolishArray");
    const selectedOptions = storedShape ? JSON.parse(storedShape) : [];
    const unselectedOptions = Cut.filter(option => !selectedOptions.some(selectedOption => selectedOption.value === option.value))
    return unselectedOptions;
  });
  const Polish = selectedOptions2.map((option) => option.code)

  const handleIntensityChange22 = (event) => {
    const selectedValue2 = event.target.value;
    if (selectedValue2 !== '') {
      const selectedOption2 = options2.find(option => option.value === selectedValue2);
      setSelectedOptions2([...selectedOptions2, selectedOption2]);
      setOptions2(options2.filter(option => option.value !== selectedValue2));
      setSelectedOption2('');
    }
  };

  const handleRemoveOption2 = (option) => {
    setSelectedOptions2(selectedOptions2.filter(item => item.value !== option.value));
    setOptions2([...options2, option]);
  };

  const handleClearSelectionPolish = () => {
    setSelectedOptions2([]);
    setOptions2(Cut);
  };

  //////////////////////// Symmetry ///////////////////////////
  const [selectedOption3, setSelectedOption3] = useState('');
  const [selectedOptions3, setSelectedOptions3] = useState(() => { const storedShape = localStorage.getItem("SymmentryArray"); return storedShape ? JSON.parse(storedShape) : []; });
  const [options3, setOptions3] = useState(() => {
    const storedShape = localStorage.getItem("SymmentryArray");
    const selectedOptions = storedShape ? JSON.parse(storedShape) : [];
    const unselectedOptions = Cut.filter(option => !selectedOptions.some(selectedOption => selectedOption.value === option.value))
    return unselectedOptions;
  });
  const Symmetry = selectedOptions3.map((option) => option.code)

  const handleIntensityChange23 = (event) => {
    const selectedValue3 = event.target.value;
    if (selectedValue3 !== '') {
      const selectedOption3 = options3.find(option => option.value === selectedValue3);
      setSelectedOptions3([...selectedOptions3, selectedOption3]);
      setOptions3(options3.filter(option => option.value !== selectedValue3));
      setSelectedOption3('');
    }
  };

  const handleRemoveOption3 = (option) => {
    setSelectedOptions3(selectedOptions3.filter(item => item.value !== option.value));
    setOptions3([...options3, option]);
  };

  const handleClearSelectionSymmetry = () => {
    setSelectedOptions3([]);
    setOptions3(Cut);
  };

  const handleQuillChange = (value) => {
    const sanitizedValue = value.replace(/\s+/g, ',');
    setStoneIdList(sanitizedValue);
  };

  const handleReceive = () => {
    navigate('/receive')
  }

  const [giaLabShapeDropdown, setGiaLabShapeDropdown] = useState(() => {
    const storedShape = localStorage.getItem("GIA_LAB_SHAPE");
    return storedShape ? JSON.parse(storedShape) : GIA_LAB_SHAPE_DATA;
  });
  const [igiLabShapeDropdown, setIgiLabShapeDropdown] = useState(() => {
    const storedShape = localStorage.getItem("IGI_LAB_SHAPE");
    return storedShape ? JSON.parse(storedShape) : IGI_LAB_SHAPE_DATA;
  });
  const [labShapeDropdownValue, setLabShapeDropdownValue] = useState(() => {
    const storedShape = localStorage.getItem("LAB_SHAPE");
    return storedShape || '';
  });
  const handleFetchGiaLabShapeDropdown = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/fetchLabShapeDropdown`, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json'
        },
        body: JSON.stringify({
          USERNAME: localStorage.getItem('USERNAME'),
          PASSWORD: localStorage.getItem('PASSWORD'),
          LAB: 'GIA'
        })
      })
      const data = await response.json();
      if (data.success) {
        setGiaLabShapeDropdown(data.data[0]);
        localStorage.setItem("GIA_LAB_SHAPE", JSON.stringify(data.data[0]));
      }
    } catch (error) {
      toast.error('Error fetching lab shape dropdown', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });
    }
  }
  const handleFetchIgiLabShapeDropdown = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/fetchLabShapeDropdown`, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json'
        },
        body: JSON.stringify({
          USERNAME: localStorage.getItem('USERNAME'),
          PASSWORD: localStorage.getItem('PASSWORD'),
          LAB: 'IGI'
        })
      })
      const data = await response.json();
      if (data.success) {
        setIgiLabShapeDropdown(data.data[0]);
        localStorage.setItem("IGI_LAB_SHAPE", JSON.stringify(data.data[0]));
      }
    } catch (error) {
      toast.error('Error fetching lab shape dropdown', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });
    }
  }

  useEffect(() => {
    if ((labCode?.includes('GIA') && labCode?.length == 1 && giaLabShapeDropdown?.length == 0) || (labCode?.includes('IGI') && labCode?.length == 1 && igiLabShapeDropdown?.length == 0)) {
      handleFetchGiaLabShapeDropdown();
      handleFetchIgiLabShapeDropdown();
    }
  }, [labCode]);

  useEffect(() => {
    if (labCode?.length > 1 || labCode?.length == 0) {
      setLabShapeDropdownValue('');
      localStorage.setItem("LAB_SHAPE", '');
    }
  }, [labCode])

  const handleSearch = async () => {
    const isLoggedIn = await loginOnReload();
    if (!isLoggedIn) {
      return;
    }
    if (ShapeName.length > -1) {
      let string = JSON.stringify(ShapeName)
      localStorage.setItem("Shape", string)
    }
    if (sizeCode.length > -1) {
      let string = JSON.stringify(sizeCode)
      localStorage.setItem("size", string)
    }

    if (sizeFrom.length > -1) {
      let size = JSON.stringify(sizeFrom)
      localStorage.setItem("sizeFrom", size)
    }
    if (sizeTo.length > -1) {
      let size = JSON.stringify(sizeTo)
      localStorage.setItem("sizeTo", size)
    }
    if (ratioFrom.length > -1) {
      let size = JSON.stringify(ratioFrom)
      localStorage.setItem("ratioFrom", size)
    }
    if (ratioTo.length > -1) {
      let size = JSON.stringify(ratioTo)
      localStorage.setItem("ratioTo", size)
    }

    if (colorCode.length > -1) {
      let string = JSON.stringify(colorCode)
      localStorage.setItem("Color", string)
    }

    localStorage.setItem("FancyOvertone", FancyOvertone.join('-'))
    localStorage.setItem("FancyIntensity", FancyIntensity.join('-'))
    localStorage.setItem("FancyColor", FancyColor.join('-'))
    localStorage.setItem("reportNo", reportNo)
    localStorage.setItem("Check", checked)
    localStorage.setItem("Location", location)
    localStorage.setItem("IS_LABGROWN", isLabGrown === true ? 'yes' : 'no')
    if (typeCode.length > -1) {
      let string = JSON.stringify(typeCode)
      localStorage.setItem("LAB_TYPE", string)
    }
    if (clarityCode.length > -1) {
      let string = JSON.stringify(clarityCode)
      localStorage.setItem("clarityCode", string)
    }
    if (cut.length > -1) {
      let string = JSON.stringify(cut)
      let string1 = JSON.stringify(selectedOptions)
      localStorage.setItem("CutArray", string1)
      localStorage.setItem("Cut", string)
    }
    if (Polish.length > -1) {
      let string = JSON.stringify(Polish)
      let string1 = JSON.stringify(selectedOptions2)
      localStorage.setItem("PolishArray", string1)
      localStorage.setItem("Polish", string)
    }
    if (Symmetry.length > -1) {
      let string = JSON.stringify(Symmetry)
      let string1 = JSON.stringify(selectedOptions3)
      localStorage.setItem("SymmentryArray", string1)
      localStorage.setItem("Symmetry", string)
    }
    if (FluoreCode.length > -1) {
      let string = JSON.stringify(FluoreCode)
      localStorage.setItem("FluoreCode", string)
    }
    if (labCode.length > -1) {
      let string = JSON.stringify(labCode)
      localStorage.setItem("labCode", string)
    }
    if (stoneIdList.length > -1) {
      let string = JSON.stringify(stoneIdList)
      localStorage.setItem("ReportNo:", string)
    }
    localStorage.setItem("LAB_SHAPE", labShapeDropdownValue)
    navigate('/inventory');
  };

  const [holdAndInquiryData, setHoldAndInquiryData] = useState({});
  const [isHoldOpen, setIsHoldOpen] = useState(false);
  const [radioValue, setRadioValue] = useState('yes');
  const [priceValue, setPriceValue] = useState('yes');
  const [radioValueOther, setRadioValueOther] = useState('AMOUNT');
  const [holdFor, setHoldFor] = useState('');
  const [otherHoldFor, setOtherHoldFor] = useState('');
  const [textValue, setTextValue] = useState('');
  const [amountValue, setAmountValue] = useState('');
  const [holdValue, setHoldValue] = useState([])
  const [showLoader, setShowLoader] = useState(false);

  const handleGetDropdownValue = async () => {
    const email = localStorage.getItem('USERNAME')
    const password = localStorage.getItem('PASSWORD')
    setShowLoader(true)
    await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/hold/value`, {
      method: 'POST',
      body: JSON.stringify({
        USERNAME: email,
        PASSWORD: password
      }),
      headers: {
        'Content-type': 'application/json'
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setShowLoader(false)
        setHoldValue(data?.data);
        if (data.success === 'TRUE') {
        } else {
          // toast.error(data.message, {
          toast.error(data.message.MSG, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      })
      .catch((err) => {
        setShowLoader(false)
      });
  }

  const handleHoldAndInquiry = async () => {
    if (stoneIdList.length == 0) {
      toast.error('Please enter stone IDs', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
      return;
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/holdandinquiry`, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json'
        },
        body: JSON.stringify({ USERNAME: localStorage.getItem('USERNAME'), PASSWORD: localStorage.getItem('PASSWORD'), STONEIDLIST: stoneIdList, STONE_TYPE: reportNo })
      })
      const data = await response.json();
      if (data.success) {
        setHoldAndInquiryData(data.data);
        if (data.data.available.length > 0) {
          handleGetDropdownValue();
          setIsHoldOpen(true);
        } else {
          toast.error('No stones are available', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      }
    } catch (error) {
      toast.error('Error holding and inquiring', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  }

  const onRadioChange = (e) => {
    if (e.target.value === 'yes') {
      setTextValue('')
      setAmountValue('')
    } else {
      if (stoneIdList.length > 1) {
        setPriceValue('no')
      } else {
        setPriceValue('yes')
      }
      setHoldFor('')
      setOtherHoldFor('')
    }
    setRadioValue(e.target.value);
  };

  const onRadioPriceChange = (e) => {
    setPriceValue(e.target.value);
  };

  const onRadioChangeOther = (e) => {
    setRadioValueOther(e.target.value);
  };

  const onTextChange = (e) => {
    setTextValue(e.target.value);
  };

  const onAmountChange = (e) => {
    const value = e.target.value;
    const regex = /^\d*\.?\d{0,4}$/; // Regex to allow numbers with up to 4 decimal places
    if (regex.test(value)) {
      setAmountValue(value);
    }
  };

  function closeModalHold() {
    setIsHoldOpen(false);
    setRadioValue('yes')
    setPriceValue('yes')
    setRadioValueOther('AMOUNT')
    setTextValue('')
    setAmountValue('')
    setHoldFor('')
    setOtherHoldFor('')
  }

  const [inquiryLoading, setInquiryLoading] = useState(false);

  const handleFetchInquiryData = async () => {
    setInquiryLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/fetchInquiryData`, {
        method: 'POST',
        body: JSON.stringify({ USERNAME: localStorage.getItem('USERNAME'), PASSWORD: localStorage.getItem('PASSWORD'), STONEIDLIST: holdAndInquiryData?.available?.map((item) => item.REPORTNO).join(',') }),
        headers: {
          'Content-type': 'application/json',
        },
      });
      const data = await response.json();
      if (data.success) {
        if (data.data.length > 0) {
          const failedRows = [];
          let completedCount = 0;
          let i = 0;
          const gapBetweenCallsMs = 2000;
          const gapAfterEveryThirdMs = 4000;

          const pushFailedRow = (sourceRow) => {
            const vm = sourceRow.VENDORMESSAGE ?? '';
            failedRows.push({
              STOCK_PREFIX: sourceRow.STOCK_PREFIX ?? '',
              VENDORMESSAGE: typeof vm === 'string' ? vm.replace(/\r\n/g, '\n').replace(/\n+$/, '') : vm
            });
          };

          const sendInquiryAtIndex = (index) => {
            const row = data.data[index];
            if (row.GROUPID?.trim() === '' || row.GROUPID === null || row.GROUPID === undefined) {
              pushFailedRow(row);
              completedCount++;
              if (completedCount === data.data.length) {
                setInquiryLoading(false);
                if (failedRows.length > 0) {
                  downloadInquiryFailedExcel(failedRows);
                }
                if (failedRows.length === data.data.length) {
                  toast.error('Inquiry not able to send.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                  });
                } else {
                  toast.success('Inquiry sent successfully.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                  });
                }
                setAmountValue('')
                setTextValue('')
                setHoldFor('')
                setOtherHoldFor('')
                setIsHoldOpen(false)
                setRadioValue('yes')
                setPriceValue('yes')
                setRadioValueOther('AMOUNT')
                setStoneIdList('');
              }
              return;
            }
            const formattedMessage = (row.VENDORMESSAGE ?? '').replace(/\r\n/g, '\n').replace(/\n+$/, '');
            const body = {
              typing_time: 0,
              to: row.GROUPID,
              body: formattedMessage,
              ...((row.WHATSAPP_GROUP_MENTION_NUMBER && row.WHATSAPP_GROUP_MENTION_NUMBER !== "") && {
                mentions: [row.WHATSAPP_GROUP_MENTION_NUMBER],
              }),
            }
            const options = {
              method: 'POST',
              headers: {
                accept: 'application/json',
                'content-type': 'application/json',
                authorization: `Bearer ${row.TOKEN}`
              },
              body: JSON.stringify(body)
            };

            fetch(row.API_URL, options)
              .then(res => res.json())
              .then(res => {
                console.log(res, 'RES123');
                if (res.status === 'failed') {
                  pushFailedRow(row);
                }
              })
              .catch(err => {
                console.error(err);
                pushFailedRow(row);
              })
              .finally(() => {
                completedCount++;
                if (completedCount === data.data.length) {
                  setInquiryLoading(false);
                  if (failedRows.length > 0) {
                    downloadInquiryFailedExcel(failedRows);
                  }
                  if (failedRows.length === data.data.length) {
                    toast.error('Inquiry not able to send.', {
                      position: "top-right",
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "dark",
                    });
                  } else {
                    toast.success('Inquiry sent successfully.', {
                      position: "top-right",
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "dark",
                    });
                  }
                  setAmountValue('')
                  setTextValue('')
                  setHoldFor('')
                  setOtherHoldFor('')
                  setIsHoldOpen(false)
                  setRadioValue('yes')
                  setPriceValue('yes')
                  setRadioValueOther('AMOUNT')
                  setStoneIdList('');
                }
              });
          };

          // setInterval(delay) uses one fixed delay forever — it cannot change per tick.
          // Here: 2s between calls 1→2 and 2→3, then 4s before 4th; same pattern before 7th, 10th, …
          const scheduleNextSend = () => {
            if (i >= data.data.length) return;
            sendInquiryAtIndex(i);
            i++;
            if (i >= data.data.length) return;
            const delayMs = i % 3 === 0 ? gapAfterEveryThirdMs : gapBetweenCallsMs;
            setTimeout(scheduleNextSend, delayMs);
          };

          scheduleNextSend();
        } else {
          toast.error('No inquiry data found', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setInquiryLoading(false);
          setAmountValue('')
          setTextValue('')
          setHoldFor('')
          setOtherHoldFor('')
          setIsHoldOpen(false)
          setRadioValue('yes')
          setPriceValue('yes')
          setRadioValueOther('AMOUNT')
          setStoneIdList('');
        }
        // setInquiryData(data.data);
      }
    } catch (error) {
      toast.error('Error fetching inquiry data', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  }
  const handleHoldKJProducts = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/holdKJItem`, {
        method: 'POST',
        body: JSON.stringify({
          STONEIDLIST: holdAndInquiryData?.available?.map((item) => item.REPORTNO).join(',')
        }),
        headers: {
          'Content-type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      // console.log(data, 'response123');
      if (data.success == true && data?.vendorlist?.length > 0) {
        const holdKJItems = await fetch(`https://diamond.aviratinfo.com/KJ/api/hold?refno=${data?.vendorlist}`,{
          method: 'POST',
        })
        if (!holdKJItems.status) {
          toast.error('Error holding KJ stones')
          throw new Error(`HTTP error! Status: ${holdKJItems.status}`);
        }
      }
    } catch (err) {
      console.error(err.message);
    }
  }

  const handleHoldItem = async (holdForData, email, value) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/holdItem`, {
        method: 'POST',
        body: JSON.stringify({
          USERNAME: email,
          STONEIDLIST: holdAndInquiryData?.available?.map((item) => item.REPORTNO).join(','),
          IS_REMOVE: value,
          IS_CLIENT: radioValue,
          HOLD_AMOUNT: parseFloat(amountValue),
          HOLD_FOR: holdForData,
          OTHER_HOLD_FOR: otherHoldFor ?? "",
          RATE_TYPE: radioValueOther,
          STONE_TYPE: reportNo
        }),
        headers: {
          'Content-type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      if (data.success == 'TRUE') {
        await handleHoldKJProducts();
        await handleFetchInquiryData();
        toast.success(data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.error(data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } catch (err) {
      console.error(err.message);
    }
  }

  const handleHoldAndInquiryButton = async (value) => {
    const email = localStorage.getItem('USERNAME')
    if (stoneIdList.length === 0) {
      toast.error('Please select stones', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else if (stoneIdList?.split(',').length > 30) {
      toast.error('You can do Maximum 30 stones at one time', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else if (value === 'no' && radioValue === 'yes' && holdFor === '') {
      toast.error("Please select Hold for", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    } else if (value === 'no' && radioValue === 'no' && textValue === '') {
      toast.error("Please enter Hold for", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    } else if (value === 'no' && radioValue === 'no' && amountValue === '' && stoneIdList.length <= 1 && priceValue === 'yes') {
      toast.error("Please enter Amount!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    } else {
      handleHoldItem(holdFor ? holdFor : textValue, email, value)
      // try {
      //     const response = await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/holdItem`, {
      //         method: 'POST',
      //         body: JSON.stringify({
      //             USERNAME: email,
      //             STONEIDLIST: selectedCertificateNos.join(', '),
      //             IS_REMOVE: value,
      //             IS_CLIENT: radioValue,
      //             HOLD_AMOUNT: parseFloat(amountValue),
      //             HOLD_FOR: holdFor ? holdFor : textValue,
      //             OTHER_HOLD_FOR: otherHoldFor ?? "",
      //             RATE_TYPE: radioValueOther
      //         }),
      //         headers: {
      //             'Content-type': 'application/json',
      //         },
      //     });

      //     if (!response.ok) {
      //         throw new Error(`HTTP error! Status: ${response.status}`);
      //     }

      //     const data = await response.json();
      //     if (data.success === 'TRUE') {
      //         toast.success(data.message, {
      //             position: "top-right",
      //             autoClose: 3000,
      //             hideProgressBar: false,
      //             closeOnClick: true,
      //             pauseOnHover: true,
      //             draggable: true,
      //             progress: undefined,
      //             theme: "dark",
      //         });
      //         setAmountValue('')
      //         setTextValue('')
      //         setHoldFor('')
      //         setOtherHoldFor('')
      //         setIsHoldModalOpen(false)
      //         setRadioValue('yes')
      //         setPriceValue('yes')
      //         setRadioValueOther('AMOUNT')
      //     } else {
      //         toast.error(data.message, {
      //             position: "top-right",
      //             autoClose: 3000,
      //             hideProgressBar: false,
      //             closeOnClick: true,
      //             pauseOnHover: true,
      //             draggable: true,
      //             progress: undefined,
      //             theme: "dark",
      //         });
      //     }
      // } catch (err) {
      //     console.error(err.message);
      // }
    }
  }

  const handleReset = async () => {
    window.location.reload();
    localStorage.removeItem("Shape");
    localStorage.removeItem("sizeFrom");
    localStorage.removeItem("sizeTo");
    localStorage.removeItem("ratioFrom");
    localStorage.removeItem("ratioTo");
    localStorage.removeItem("size");
    localStorage.removeItem("Color");
    localStorage.removeItem("FancyOvertone");
    localStorage.removeItem("FancyIntensity");
    localStorage.removeItem("FancyColor");
    localStorage.removeItem("reportNo");
    localStorage.removeItem("Check");
    localStorage.removeItem("clarityCode");
    localStorage.removeItem("Cut");
    localStorage.removeItem("Polish");
    localStorage.removeItem("Symmetry");
    localStorage.removeItem("FluoreCode");
    localStorage.removeItem("labCode");
    localStorage.removeItem("ReportNo:");
    localStorage.removeItem("SymmentryArray");
    localStorage.removeItem("PolishArray");
    localStorage.removeItem("CutArray");
    localStorage.removeItem("Location");
    localStorage.removeItem("IS_LABGROWN");
    localStorage.removeItem("LAB_TYPE");
    localStorage.removeItem("LAB_SHAPE");
  };

  function openModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }

  const handleLogOut = async () => {
    // await removeFcmToken()
    localStorage.removeItem('USERNAME')
    localStorage.removeItem('PASSWORD')
    localStorage.removeItem('IS_HOLD')
    localStorage.removeItem('IS_CONFIRM')
    localStorage.removeItem('IS_CLIENT_PRICE')
    localStorage.removeItem('IS_VENDOR')
    localStorage.removeItem('IS_STAFF')
    localStorage.removeItem('IS_RECEIVE')
    localStorage.removeItem('IS_EXCEL_INWARD')
    localStorage.removeItem('IS_VENDOR_NAME')
    localStorage.removeItem('IS_CLIENT_WEB')
    localStorage.removeItem('IS_SHOW_HOLD_BUTTON')
    localStorage.removeItem('IS_PRICE_EXCEL')
    localStorage.removeItem('IS_HOLD_INQURY')
    navigate('/')
  };

  const handleHoldButton = () => {
    navigate('/inventory?showHold=true');
  };

  return (
    <div>
      <ToastContainer />
      <div className='maindiv1 bg-gray-200 rounded-lg m-5 p-4 flex flex-col md:flex-row items-center md:items-start'>
        <div className='flex md:flex-col justify-start w-full md:w-[90px]'>
          <div className='flex heading text-lg font-medium w-full md:w-[80px] justify-start items-center md:justify-normal'>
            Shape
            {ShapeName.length > 0 && (
              <span className='pl-1' onClick={handleClearSelection}>
                <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full' alt='Close' />
              </span>
            )}
          </div>
          <div className='flex linkbtn absolute md:static left-28 top-2.5 cursor-pointer underline !text-blue-500 !w-28 justify-center md:justify-normal ' onClick={handleSelectAllClick}>
            <span className='w-max'>{selectAllChecked ? 'Deselect All' : "Select All"}</span>
          </div>
        </div>
        <div className='flex flex-wrap gap-2 w-full md:w-auto justify-center md:justify-normal'>
          {Shape?.map((shap, index) => (
            <div key={index} className={`box rounded-md border-2 border-gray-400 ${ShapeName.includes(shap.code) ? 'selected' : ''}`} onClick={() => handleBoxClick(shap.code)}>
              <div className='w-full flex justify-center items-center'>
                <img src={shap.image} className='self-center w-12 h-12 md:w-16 md:h-16' />
              </div>
              <div className='shapName text-sm md:text-md text-center'>{shap.name}</div>
            </div>
          ))}
        </div>
        <button onClick={openModal} class="logout1-hover absolute top-4 right-6 px-3 py-1" >
          Log Out
        </button>
      </div>

      <div className='maindiv bg-gray-200 rounded-lg flex flex-col md:flex-row' onTouchStart={(e) => e.preventDefault()}>
        <div className=' flex items-center self-start w-full md:w-auto'>
          <div className='heading text-lg font-medium w-[90px] flex'>
            Size
            {sizeCode.length > 0 && (
              <span className='pl-1' onClick={handleClearSelection2}>
                <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full' alt='Close' />
              </span>
            )}
          </div>
          <div className='FromTo flex flex-row items-center ml-4 md:ml-2'>
            <input
              type='number'
              value={sizeFrom}
              placeholder='From...'
              className='h-8 w-16 px-2 outline-none text-center'
              autoFocus={false}
              onChange={Fromdata}
              maxLength={3}
            />
            <span className='mx-2'>-</span>
            <input
              type='number'
              value={sizeTo}
              placeholder='To...'
              autoFocus={false}
              className='h-8 w-16 px-2 outline-none text-center'
              onChange={Todata}
            />
          </div>
        </div>

        <div className='downPart flex flex-col md:flex-row items-center justify-center md:justify-start gap-4 w-full'>
          <div className=' grid grid-cols-4 md:flex md:flex-wrap gap-2 md:gap-3 w-full md:w-auto justify-center md:pl-20'>
            {Size?.map((size, index) => (
              <div key={index} className={`box2 rounded-md border border-gray-400 text-center ${sizeCode.includes(size.code) ? 'selected' : ''}`} onClick={() => handleBoxClick2(size.code)}>
                <div className='shapName text-xs md:text-sm text-center' >{size.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className='maindiv bg-gray-200 rounded-lg m-5 p-4 flex flex-col md:flex-row'>
        <div className='heading text-lg font-medium w-full md:w-[85px] flex'>
          Color
          {colorCode.length > 0 && (
            <span className='pl-1' onClick={handleClearSelection3}>
              <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full' alt='Close' />
            </span>
          )}
        </div>

        <div className='spacebetween flex flex-col md:flex-row gap-4 w-full'>
          <div className='w-auto md:w-[60%] flex flex-wrap gap-1 '>
            {Color?.map((color, index) => (
              <div className='FromTo' key={index}>
                <div className={`colortext1 ${colorCode.includes(color.code) ? 'selected' : ''}`} style={{ backgroundColor: checked ? "#eaf3f6" : "white" }} onClick={() => {
                  if (checked) {
                  } else {
                    handleBoxClick3(color.code)
                  }
                }}>
                  {color.name}
                </div>
              </div>
            ))}
          </div>

          <div className='grid grid-rows-4 md:grid-rows-2 2xl:grid-rows-2 grid-flow-col gap-2 gap-x-4 w-full md:w-[40%]'>
            <div className='flex items-center md:items-start w-full md:w-auto gap-2'>
              <div className='colorname w-max' >
                <span><input type='checkbox' checked={checked} onChange={handelCheck} /> Fancy Color</span>
              </div>
              <div className='flex items-center gap-2'>
                <input
                  type='text'
                  value={hiddenInputValue}
                  onChange={handleHiddenInputChange}
                  placeholder=''
                  tabIndex={0}
                  style={{
                    backgroundColor: 'transparent',
                    border: 'none',
                    outline: 'none',
                    width: '40px',
                  }}
                  autoComplete='off'
                />
                {showRefButton && (
                  <button
                    onClick={handleRefreshFancyData}
                    disabled={loading}
                    className='ml-2 px-3 py-[2px] bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-400 disabled:cursor-not-allowed'
                    style={{ fontSize: '12px' }}
                  >
                    {loading ? 'Loading...' : 'Ref.'}
                  </button>
                )}
              </div>
            </div>

            <div className='flex items-center mb-2 md:mb-0 gap-2'>
              <div className='colorname flex items-center'>
                Intensity
                {FancyIntensity.length > 0 && (
                  <span className='pl-1' onClick={() => setFancyIntensity([])}>
                    <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full' alt='Clear Intensity' />
                  </span>
                )}
              </div>
              <div className="dropdown w-[200px]">
                <div className="selected-options bg-white border border-black flex flex-wrap gap-1 md:flex p-1 mx-w-20 md:w-auto">
                  {FancyIntensity.map((value, index) => (
                    <div key={index} className='border border-black bg-gray-100 rounded-xl px-2 py-[2px] flex items-center gap-1'>
                      {value}
                      <img
                        src={CloseImg}
                        className='cursor-pointer h-4 w-4'
                        alt='Remove'
                        onClick={() => setFancyIntensity(FancyIntensity.filter(item => item !== value))}
                      />
                    </div>
                  ))}

                  {fancyIntensityList.filter(v => !FancyIntensity.includes(v)).length > 0 && (
                    <select
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        if (!selectedValue) return;
                        setFancyIntensity([...FancyIntensity, selectedValue]);
                      }}
                      value=""
                      disabled={!checked}
                      className='select-style'
                      style={{ maxWidth: '70px' }}
                    >
                      <option value='' className='bg-gray-200' disabled>Select</option>
                      {fancyIntensityList
                        .filter(v => !FancyIntensity.includes(v))
                        .map((intensity, index) => (
                          <option key={index} value={intensity}>{intensity}</option>
                        ))}
                    </select>
                  )}
                </div>
              </div>
            </div>

            <div className='flex items-center mb-2 md:mb-0 gap-2'>
              <div className='colorname flex items-center min-w-[70px]'>
                Overtone
                {FancyOvertone.length > 0 && (
                  <span className='pl-1' onClick={() => setFancyOvertone([])}>
                    <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full' alt='Clear Overtone' />
                  </span>
                )}
              </div>
              <div className="dropdown w-[200px]">
                <div className="selected-options bg-white border border-black flex flex-wrap gap-1 md:flex p-1 ">
                  {FancyOvertone.map((value, index) => (
                    <div key={index} className='border border-black bg-gray-100 rounded-xl px-2 py-[2px] flex items-center gap-1 '>
                      {value}
                      <img
                        src={CloseImg}
                        className='cursor-pointer h-4 w-4'
                        alt='Remove'
                        onClick={() => setFancyOvertone(FancyOvertone.filter(item => item !== value))}
                      />
                    </div>
                  ))}

                  {fancyOvertoneList.filter(v => !FancyOvertone.includes(v)).length > 0 && (
                    <select
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        if (!selectedValue) return;
                        setFancyOvertone([...FancyOvertone, selectedValue]);
                      }}
                      value=""
                      disabled={!checked}
                      className='select-style'
                      style={{ maxWidth: '70px' }}
                    >
                      <option value='' className='bg-gray-200' disabled>Select</option>
                      {fancyOvertoneList
                        .filter(v => !FancyOvertone.includes(v))
                        .map((overtone, index) => (
                          <option key={index} value={overtone}>{overtone}</option>
                        ))}
                    </select>
                  )}
                </div>
              </div>
            </div>

            <div className='flex items-center gap-2'>
              <div className='colorname flex items-center justify-end min-w-[70px] '>
                Color
                {FancyColor.length > 0 && (
                  <span className='pl-1' onClick={() => setFancyColor([])}>
                    <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full' alt='Clear Color' />
                  </span>
                )}
              </div>
              <div className="dropdown w-[200px]">
                <div className="selected-options bg-white border border-black flex flex-wrap gap-1 md:flex p-1 mx-w-20 md:w-auto">
                  {FancyColor.map((value, index) => (
                    <div key={index} className='border border-black bg-gray-100 rounded-xl px-2 py-[2px] flex items-center gap-2 md:w-max'>
                      {value}
                      <img
                        src={CloseImg}
                        className='cursor-pointer h-4 w-4'
                        alt='Remove'
                        onClick={() => setFancyColor(FancyColor.filter(item => item !== value))}
                      />
                    </div>
                  ))}

                  {fancyColorList.filter(v => !FancyColor.includes(v)).length > 0 && (
                    <select
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        if (!selectedValue) return;
                        setFancyColor([...FancyColor, selectedValue]);
                      }}
                      value=""
                      disabled={!checked}
                      className='select-style'
                      style={{ maxWidth: '70px' }}
                    >
                      <option value='' className='bg-gray-200' disabled>Select</option>
                      {fancyColorList
                        .filter(v => !FancyColor.includes(v))
                        .sort((a, b) => a.localeCompare(b))
                        .map((color, index) => (
                          <option key={index} value={color}>{color}</option>
                        ))}
                    </select>
                  )}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className='maindiv bg-gray-200 rounded-lg m-5 p-4 flex flex-col md:flex-row'>
        <div className='heading font-medium md:w-[85px] flex self-start '>
          Clarity
          {clarityCode.length > 0 && (
            <span className='pl-1' onClick={handleClearSelection4}>
              <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full' alt='Close' />
            </span>
          )}
        </div>
        <div className='spacebetween flex flex-col md:flex-row gap-4 w-full'>
          <div className='md:w-max flex flex-wrap !gap-1'>
            {Clarity?.map((clarity, index) => (
              <div className='FromTo text-[15px]' key={index}>
                <div className={`colortext ${clarityCode.includes(clarity.code) ? 'selected' : ''}`} onClick={() => handleBoxClick4(clarity.code)}>
                  {clarity.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className='maindiv bg-gray-200 rounded-lg m-5 p-4 flex flex-col md:flex-row'>
        <div className=' flex md:flex md:flex-row w-full md:w-1/3 items-center '>
          <div className='md:flex  md:flex-row  md:justify-start md:items-center gap-20 w-full md:w-1/2 md:h-[40px]'>

            <div className='flex items-center mb-2 md:mb-0'>
              <div className='w-24 text-lg font-medium colorname flex' >
                Cut &nbsp;
                {selectedOptions.length > 0 && (
                  <span className='pl-1' onClick={handleClearSelectioncut}>
                    <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full' alt='Close' />
                  </span>
                )}
              </div>
              <div className="dropdown">
                <div className="selected-options bg-white border border-black grid grid-cols-3 gap-3 md:flex p-1 mx-w-20 md:w-auto">
                  {selectedOptions.map((option, index) => (
                    <div key={index} className='border border-black bg-gray-100 rounded-xl p-1 flex items-center gap-2 md:w-12'>
                      {option.label}
                      <img src={CloseImg} className='cursor-pointer h-4 w-4' onClick={() => handleRemoveOption(option)} />
                    </div>
                  ))}

                  {options.length > 0 ? (
                    <select onChange={handleIntensityChange2} value={selectedOption} className='select-style'>
                      <option value='' className='bg-gray-200' disabled>Select</option>
                      {options
                        .filter(option => !selectedOptions.some(selectedOption => selectedOption.value === option.value)) // Filter out selected options
                        .sort((a, b) => a.label.localeCompare(b.label))
                        .map((option, index) => (
                          <option key={index} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                  ) : null}

                </div>
              </div>
            </div>

            <div className='flex md:items-center md:justify-center mb-2 md:mb-0'>
              <div className='w-24 md:w-[67px] text-lg font-medium colorname flex'>
                Polish
                {selectedOptions2.length > 0 && (
                  <span onClick={handleClearSelectionPolish}>
                    <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full ml-1' alt='Close' />
                  </span>
                )}
              </div>
              <div className="dropdown">
                <div className="selected-options bg-white border border-black grid grid-cols-3 gap-3 md:flex mx-w-20 md:w-auto p-1" >
                  {selectedOptions2.map((option, index) => (
                    <div key={index} className='selected-option border border-black bg-gray-100 rounded-xl p-1 flex items-center gap-2 md:w-12'>
                      {option.label}
                      <img src={CloseImg} className='cursor-pointer h-4 w-4' onClick={() => handleRemoveOption2(option)} />
                    </div>
                  ))}
                  {options2.length > 0 ? (
                    <select onChange={handleIntensityChange22} value={selectedOption2} className='select-style'>
                      <option value='' className='bg-gray-200' disabled >Select</option>
                      {options2
                        .filter(option => !selectedOptions2.some(selectedOption => selectedOption.value === option.value)) // Filter out selected options
                        .sort((a, b) => a.label.localeCompare(b.label))
                        .map((option, index) => (
                          <option key={index} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>

            <div className='flex items-center mb-2 md:mb-0'>
              <div className='w-24 md:w-[105px] text-lg font-medium colorname flex'>
                Symmetry
                {selectedOptions3.length > 0 && (
                  <span className='pl-1' onClick={handleClearSelectionSymmetry}>
                    <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full' alt='Close' />
                  </span>
                )}
              </div>
              <div className="dropdown">
                <div className="selected-options bg-white border border-black grid grid-cols-3 gap-3 md:flex mx-w-20 md:w-auto p-1" >
                  {selectedOptions3.map((option, index) => (
                    <div key={index} className='selected-option border border-black bg-gray-100 rounded-xl p-1 flex items-center gap-2 md:w-12' >
                      {option.label}
                      <img src={CloseImg} className='cursor-pointer h-4 w-4' onClick={() => handleRemoveOption3(option)} />
                    </div>
                  ))}
                  {options3.length > 0 ? (
                    <select onChange={handleIntensityChange23} value={selectedOption3} className='select-style'>
                      <option value='' className='bg-gray-200' disabled >Select</option>
                      {options3
                        .filter(option => !selectedOptions3.some(selectedOption => selectedOption.value === option.value)) // Filter out selected options
                        .sort((a, b) => a.label.localeCompare(b.label))
                        .map((option, index) => (
                          <option key={index} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='maindiv bg-gray-200 rounded-lg flex flex-col md:flex-row border' >
        <div className='heading text-lg font-medium w-full md:w-[85px] flex '>
          Fluore
          {FluoreCode.length > 0 && (
            <span className='pl-1' onClick={handleClearSelection6}>
              <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full' alt='Close' />
            </span>
          )}
        </div>
        <div className='downPart flex flex-wrap gap-4 items-center'>
          {Floro.map((Floro, index) => (
            <div className='FromTo' key={index}>
              <div className={`FluorescenceOption ${FluoreCode.includes(Floro.code) ? 'selected' : ''}`} onClick={() => handleBoxClick6(Floro.code)}>
                {Floro.name}
              </div>
            </div>
          ))}

          {
            isVendor == 'TRUE' ?
              <div style={{ marginLeft: window.innerWidth <= 450 && '-19px' }} className='md:ml-10 flex items-start md:!items-center mt-5 md:mt-0 !justify-center md:w-[50%] w-[100%] gap-2 md:gap-0'  >
                {/* <label class="labelname pt-1 pr-1">ReportNo:</label> */}
                {/* <div className='colorname w-20 md:w-auto'>Color &nbsp;</div> */}
                <div className='flex flex-col md:flex-row items-center gap-2 md:w-[20%] w-[50%]'>
                  <select onChange={(e) => setReport(e.target.value)} value={reportNo} className={`!w-full mr-3`}>
                    <option value='CERT' className='bg-gray-200 labelname pt-1 pr-1' selected >ReportNo</option>
                    <option value='STOCK'>StockID </option>
                    <option value='VENDOR'>VendorID </option>
                    <option value='CLIENT'>ClientID</option>
                    <option value='MEDIA'>MediaID</option>
                  </select>
                  {localStorage.getItem('IS_HOLD_INQURY') === 'TRUE' && <button className='buttonSearch !w-[120px] md:hidden mr-3 mt-5' onClick={handleHoldAndInquiry}>Hold & Inquiry</button>}
                </div>
                <div class="quill-container flex flex-col md:flex-row items-center gap-2 md:w-[80%] w-[50%]">
                  {/* <input
                    id='yourInputId'
                    value={stoneIdList}
                    className='input1'
                    onChange={(e) => handleQuillChange(e.target.value)}
                    style={{ width: "100%", border: "1px solid grey" }}
                    required
                  /> */}
                  <textarea
                    id='yourInputId'
                    value={stoneIdList}
                    className='input1 md:w-[270px] w-[150px]'
                    onChange={(e) => handleQuillChange(e.target.value)}
                    style={{ border: "1px solid grey" }}
                    required
                    rows={3}
                  />
                  {localStorage.getItem('IS_HOLD_INQURY') === 'TRUE' && <button className='buttonSearch !w-[180px] hidden md:block' onClick={handleHoldAndInquiry}>Hold & Inquiry</button>}
                </div>
              </div>
              :
              <div style={{ marginLeft: window.innerWidth <= 450 && '-19px' }} className='md:ml-10 flex !items-center mt-5 md:mt-0 !justify-center '  >
                <label class="labelname pt-1 pr-1">ReportNo:</label>
                <div class="quill-container">
                  <input
                    id='yourInputId'
                    value={stoneIdList}
                    className='input1'
                    onChange={(e) => handleQuillChange(e.target.value)}
                    style={{ width: "100%", border: "1px solid grey" }}
                    required
                  />
                </div>
              </div>
          }
        </div>
      </div>

      <div className='maindiv m-5 p-4 flex flex-col md:flex-row items-center bg-gray-200 rounded-lg'>
        <div>
          <div className=' flex flex-col md:flex-row gap-3'>
            <div className='flex flex-col md:flex-row gap-4 md:pr-8'>
              <div className='flex md:flex md:flex-row w-full md:w-max items-center h-10 '>
                <div className='heading text-lg font-medium self-start flex items-center h-full pr-0 md:pr-5 w-[65px] md:w-[80px] '>
                  Lab
                  {labCode.length > 0 && (
                    <span className='pl-1' onClick={handleClearSelection7}>
                      <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full' alt='Close' />
                    </span>
                  )}
                </div>

                <div className='flex flex-col md:flex-row gap-4 px-4'>
                  <div className='downPart w-full md:w-1/3'>
                    {Labdata.map((Labdata, index) => (
                      <div className='FromTo' key={index}>
                        <div className={`colortext ${labCode.includes(Labdata.code) ? 'selected' : ''}`} onClick={() => handleBoxClick7(Labdata.code)} >
                          {Labdata.name}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {(labCode?.includes('GIA') || labCode?.includes('IGI')) && labCode?.length == 1 && <div className='flex items-center gap-2 justify-center md:hidden'>
                <div className='font-medium font-poppins'>Lab Shape</div>
                <div className='dropdown'>
                  <select onChange={(e) => setLabShapeDropdownValue(e.target.value)} value={labShapeDropdownValue}
                    className='w-[190px]  selected-options bg-white border border-black grid grid-cols-3 gap-3 md:flex p-1 mx-w-20 md:w-auto'>
                    <option value='' className='bg-gray-200'>Select</option>
                    {labCode[0] === 'GIA' ? giaLabShapeDropdown?.map((labShape, index) => (
                      <option key={index} value={labShape.LAB_SHAPE}>{labShape.LAB_SHAPE}</option>
                    )) : labCode[0] === 'IGI' ? igiLabShapeDropdown?.map((labShape, index) => (
                      <option key={index} value={labShape.LAB_SHAPE}>{labShape.LAB_SHAPE}</option>
                    )) : <></>}
                  </select>
                </div>
              </div>}
            </div>


            <div className='flex-row mt-2 md:mt-0 md:w-max w-full flex items-center'>
              <div className='font-poppins text-lg font-medium w-20'>Location &nbsp;</div>
              <select onChange={(e) => setLocation(e.target.value)} value={location} className={`w-[190px] md:w-32 border border-black bg-white p-1`}>
                <option value='' className='bg-white' selected >Select</option>
                <option value='INDIA'>INDIA</option>
                <option value='USA'>USA</option>
                <option value='UAE'>UAE</option>
                <option value='HONGKONG'>HONGKONG</option>
                <option value='BANGKOK'>BANGKOK </option>
              </select>
            </div>
            <div>
              <div className='flex mt-2 flex-row md:ml-4 mr-5 md:mr-0 gap-3 md:mt-[8px] items-center'>
                <label className='flex gap-2 w-full md:w-max flex-row items-center'>
                  <input
                    type="radio"
                    value="LabGrown"
                    checked={isLabGrown}
                    onChange={handleRadioButtonChange}
                  />
                  Lab Grown
                </label>
                <label className='flex gap-2 md:ml-0 ml-5 flex-row items-center'>
                  <input
                    type="radio"
                    value="Natural"
                    checked={!isLabGrown}
                    onChange={handleRadioButtonChange}
                  />
                  Natural
                </label>
              </div>
            </div>
          </div>
          <div className=' flex flex-col md:flex-row !mb-4 justify-end gap-3'>
            {(labCode?.includes('GIA') || labCode?.includes('IGI')) && labCode?.length == 1 && <div className='items-center hidden md:flex w-[319px] gap-3'>
              <div className='font-medium font-poppins w-[85px]'>Lab Shape</div>
              <select onChange={(e) => setLabShapeDropdownValue(e.target.value)} value={labShapeDropdownValue} className='w-[200px] border border-black bg-white p-1'>
                <option value='' className='bg-gray-200' >Select</option>
                {labCode[0] === 'GIA' ? giaLabShapeDropdown?.map((labShape, index) => (
                  <option key={index} value={labShape.LAB_SHAPE}>{labShape.LAB_SHAPE}</option>
                )) : labCode[0] === 'IGI' ? igiLabShapeDropdown?.map((labShape, index) => (
                  <option key={index} value={labShape.LAB_SHAPE}>{labShape.LAB_SHAPE}</option>
                )) : <></>}
              </select>
            </div>}
            <div className=' flex items-center self-start w-full md:w-auto pt-3'>
              <div className='heading text-lg font-medium  flex'>
                Ratio
              </div>
              <div className='FromTo flex flex-row items-center ml-4 md:ml-2'>
                <input
                  type='number'
                  value={ratioFrom}
                  placeholder='From...'
                  className='h-8 w-16 px-2 outline-none text-center'
                  autoFocus={false}
                  onChange={ratioFromdata}
                  maxLength={3}
                />
                <span className='mx-2'>-</span>
                <input
                  type='number'
                  value={ratioTo}
                  placeholder='To...'
                  autoFocus={false}
                  className='h-8 w-16 px-2 outline-none text-center'
                  onChange={ratioTodata}
                />
              </div>
            </div>
            <div className=' flex items-center self-start w-full md:w-[215px] mt-3'>
              {isLabGrown && <div className='relative heading text-lg font-medium self-start flex items-center h-full pr-0 ml-4 w-[65px] md:w-[50px] '>
                Type
                {typeCode.length > 0 && (
                  <span className='pl-1 absolute right-0 -top-2' onClick={() => setTypeCode([])}>
                    <img src={CloseImg} className='cursor-pointer h-4 w-4 rounded-full' alt='Close' />
                  </span>
                )}
              </div>}

              {isLabGrown && <div className='flex flex-col md:flex-row gap-4'>
                <div className='downPart w-full md:w-auto'>
                  {Type.map((type, index) => (
                    <div className='FromTo' key={index}>
                      <div className={`colortext ${typeCode.includes(type.code) ? 'selected' : ''} !p-[2px]`} onClick={() => handleTypeSelection(type.code)} >
                        {type.name}
                      </div>
                    </div>
                  ))}
                </div>
              </div>}
            </div>
          </div>
        </div>
        <div className='w-full flex flex-row flex-wrap justify-center md:justify-start md:pl-5 gap-3'>
          <button class="buttonSearch" onClick={handleSearch}>
            Search
          </button>
          <button class="buttonSearch" onClick={handleReset}>
            Reset
          </button>
          {localStorage.getItem('IS_SHOW_HOLD_BUTTON') === 'TRUE' && (
            <button class="buttonSearch" onClick={handleHoldButton}>
              Show Hold
            </button>
          )}
          {localStorage.getItem('IS_RECEIVE') === 'TRUE' && (
            <button class="buttonSearch" onClick={handleReceive}>
              Receive Report
            </button>
          )}
        </div>
      </div>


      <Modal open={modalIsOpen} footer={null} width={305} closable={false} onCancel={closeModal} centered>
        <label style={{ width: "100%", textAlign: "center", marginLeft: "44px" }}>Are you sure want to Logout?</label>
        <div style={{ display: "flex", justifyContent: "center", gap: "15px", marginTop: "10px" }}>
          <button className='hold-hover' onClick={handleLogOut}>
            Yes
          </button>
          <button className='confirm-hover' onClick={closeModal}>
            No
          </button>
        </div>
      </Modal>

      {inquiryLoading && <div className='z-[9999] flex justify-center items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-black bg-opacity-50'>
        <RotatingLines
          visible={true}
          height="50"
          width="50"
          color="grey"
          strokeWidth="5"
          animationDuration="0.75"
          ariaLabel="rotating-lines-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>}
      <Modal destroyOnClose={true} open={isHoldOpen} footer={null} width={355} style={{ height: "350px !important" }} closable={false} onCancel={closeModalHold} onOk={false} centered>
        <div>
          <div style={{ display: "flex", justifyContent: "end", gap: "15px", marginTop: "10px" }}>
            <IoClose style={{ position: "absolute", top: "15px", right: "18px" }} className='close-hover' onClick={closeModalHold} size={20} />
          </div>

          {holdAndInquiryData?.notAvailable?.length > 0 && (
            <div className=''>
              <div className='mb-1'><span className='text-red-500 font-semibold'>Note</span> : Only available stones will be hold.</div>
              <div className='flex flex-wrap gap-2'>
                <table className='w-full border-collapse border border-gray-300'>
                  <thead className='bg-gray-100'>
                    <tr>
                      <th className='border border-gray-300 p-2'> Not Available ReportNo List</th>
                    </tr>
                  </thead>
                  <tbody>
                    {holdAndInquiryData?.notAvailable?.map((item, index) => (
                      <tr key={index} className='hover:bg-gray-50 text-center'>
                        <td className='border border-gray-300 p-2'>{item.REPORTNO}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div style={{ height: radioValue === 'yes' ? "140px" : "260px" }} >
            <div style={{ marginTop: "20px", justifyContent: "center", display: "flex" }}>
              <Radio.Group onChange={onRadioChange} value={radioValue}>
                <Radio value="yes" className='font-bold mr-5 text-[15px]'>Client</Radio>
                <Radio value="no" className='font-bold text-[15px]'>Other</Radio>
              </Radio.Group>
            </div>
            {
              radioValue === 'yes' &&
              <>
                <div className='flex mt-4 items-center'>
                  <div className='colorname'>Hold For &nbsp;</div>
                  <select onChange={(e) => {
                    setHoldFor(e.target.value)
                  }} style={{ width: "79%", outline: "none", borderRadius: "5px", height: "35px", padding: "7px", border: "1px solid black", }} value={holdFor} className={`border border-black bg-[#ffffff]`}>
                    {/* <option value='' className='bg-gray-200' selected >Select</option> */}
                    <option value='' className='bg-gray-200' selected >Select</option>
                    {holdValue?.map((item, index) => (
                      <option key={index} value={item.SUPPCODE}>{item.SUPPCODE}</option>
                    ))}
                  </select>
                </div>
              </>
            }

            {
              radioValue === 'no' &&
              <div className='mt-4'>
                <>
                  <div className='flex items-center'>

                    <div className='colorname'>&nbsp; &nbsp; Hold For</div>
                    <input
                      type="text"
                      placeholder="Hold For"
                      onChange={onTextChange}
                      value={textValue}
                      style={{ outline: "none", borderRadius: "5px", padding: "6px", border: "1px solid black", width: priceValue == 'yes' ? "75%" : "75%", marginLeft: priceValue == 'yes' ? "8px" : "8px" }}
                    />
                  </div>
                </>

                <div style={{ marginTop: "20px", justifyContent: "center", display: "flex" }}>
                  <Radio.Group onChange={onRadioPriceChange} value={priceValue}>
                    <Radio value="yes" className='font-bold mr-5 text-[15px]'>Manual Price</Radio>
                    <Radio value="no" className='font-bold text-[15px]'>Client Price</Radio>
                  </Radio.Group>
                </div>
              </div>
            }

            {/* Amount Input */}
            {
              radioValue === 'no' &&
              (priceValue === 'yes' ?
                <div className=''>
                  <>
                    <div style={{ marginTop: "10px", justifyContent: "center", display: "flex" }}>
                      <Radio.Group onChange={onRadioChangeOther} value={radioValueOther}>
                        <Radio value="AMOUNT" className='font-bold mr-5 text-[15px]'>Amount</Radio>
                        <Radio value="RATE" className='font-bold text-[15px]'>$/CT</Radio>
                      </Radio.Group>
                    </div>
                    <div className='flex items-center'>
                      <div className='colorname' style={{ marginLeft: "15px", width: "59.5px", textAlign: "end", paddingTop: "9px" }}>{radioValueOther === 'AMOUNT' ? 'Amount' : '$/CT'} &nbsp;</div>
                      <input
                        type="number"
                        placeholder={radioValueOther === 'AMOUNT' ? 'Amount' : '$/CT'}
                        className='ml-1'
                        style={{ outline: "none", marginTop: "10px", borderRadius: "5px", padding: "6px", border: "1px solid black", width: "30%", textAlign: "right", }}
                        step="0.0001"
                        value={amountValue}
                        onChange={onAmountChange}
                      />
                    </div>
                  </>
                </div>
                :
                <div className=''>
                  <>
                    <div className='flex mt-4 items-center'>
                      <div className='colorname'>Hold Client &nbsp;</div>
                      <select onChange={(e) => {
                        setOtherHoldFor(e.target.value)
                      }} style={{ width: "75%", outline: "none", borderRadius: "5px", height: "35px", padding: "7px", border: "1px solid black", }} value={otherHoldFor} className={`border border-black bg-[#ffffff]`}>
                        {/* <option value='' className='bg-gray-200' selected >Select</option> */}
                        <option value='' className='bg-gray-200' selected >Select</option>
                        {holdValue?.map((item, index) => (
                          <option key={index} value={item.SUPPCODE}>{item.SUPPCODE}</option>
                        ))}
                      </select>
                    </div>
                  </>
                </div>)
            }


            <div className='flex flex-row justify-center mt-4 '>
              <button onClick={() => { handleHoldAndInquiryButton('no') }} class='hold-hover !w-[150px]'>
                Hold & Inquiry
              </button>
            </div>
          </div>

          {/* <span style={{ fontWeight: "600", color: "black", fontFamily: "Poppins", }}>ReportNo: <b style={{ fontFamily: "Poppins", letterSpacing: "0.2px", color: "blue" }}>{detailes[0] && detailes[0]['Certificate No']}</b></span>
                            <div id="gridTable" style={gridStyle1} class="ag-theme-alpine">
                               
                            </div> */}
        </div>
      </Modal>
    </div >
  );
}



export default Search;